module.exports = __webpack_public_path__ + "img/0-sm.fa566331.jpg";